//
//
//
//
import { request } from '@/api/service';
import utils from '@/utils';
import axios from 'axios';
export default {
  name: 'device-recharge',
  props: {
    src: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function data() {
    return {
      url: ''
    };
  },
  created: function created() {
    var devicerechargethis = this;
    var device_number = this.$route.query.device_number;
    request({
      method: 'post',
      url: '/api/device-recharge/create/recharge',
      data: {
        'device_number': device_number
      }
    }).then(function (res) {
      var app_id = res.app_id;
      var sign = res.sign;
      var market_id = res.market_id;
      var device_number = res.device_number;
      var order_no = res.order_no;
      var uqKey = res.uqKey;
      var dev_start_server_time = res.start_servcie_time;
      var dev_end_server_time = res.end_service_time;
      var src = res.src;
      axios.post(src, {
        'app_id': app_id,
        'order_no': order_no,
        'market_id': market_id,
        'device_number': device_number,
        'dev_start_server_time': dev_start_server_time,
        'dev_end_server_time': dev_end_server_time,
        'uqKey': uqKey,
        'sign': sign
      }).then(function (response) {
        console.log(response);

        if (response.data.code == 200) {
          var redis_token = response.data.data;
          devicerechargethis.url = src + '.html?redis_token=' + redis_token; // utils.open(devicerechargethis.url)
          // devicerechargethis.url = '/xufei2.html?redis_token=' +　redis_token
        }
      }).catch(function (error) {
        console.log(error);
      });
      /* request({
        method: 'post',
        url: src,
        data: {
          'app_id': app_id,
          'order_no': order_no,
          'market_id': market_id,
          'device_number': device_number,
          'dev_start_server_time': dev_start_server_time,
          'dev_end_server_time': dev_end_server_time,
          'uqKey': uqKey,
          'sign': sign
        }
      }).then((res) => {
        console.log(res.data)
        this.url = src + '.html?redis_token=' + res.data
      }) */
    });
  }
};